<template>
  <b-modal
    centered
    hide-header-close
    ref="value-help-modal-ref"
    :size="attrs.size || 'lg'"
    cancel-variant="outline-primary"
    :id="`${attrs.name}-modal-value-help`"
    :title="attrs.modalTitle || $t('global.form.select') + ` ${context.label}`"
    :ok-title="attrs.okTitle || $t('global.action.apply')"
    :cancel-title="attrs.cancelTitle || $t('global.action.cancel')"
    :ok-disabled="isEditing || isEmpty"
    @hidden="handleHide"
    @ok="handleApply"
  >
    <div class="mc-value-help">
      <!-- Slot untuk detail data yang dipilih -->
      <slot name="detail"></slot>
      
      <LocalTable
        ref="table-modal-ref"
        :isBusy.sync="isBusy"
        :totalCount.sync="totalCount"
        :isEditing.sync="isEditing"
        :selectedModel="context.model"
        :fullObject="fullObject"
        :attrs="attrs"
        :multiple="multiple"
        :listGetter="attrs.listGetter"
        :selectable="attrs.selectable"
        @row-selected="handleRowSelected"
        @addNewData="$emit('addNewData')"
        @update:header-filter-full-object="(payload) => $emit('update:header-filter-full-object', payload)"
      >
        <template v-for="val in slotFields" v-slot:[val.name]="{ item, value }">
          <slot :name="val.name" :item="item" :value="value"></slot>
        </template>
      </LocalTable>
      <Footer :totalCount="totalCount" />
    </div>
    <template v-if="attrs?.cancelOnly" #modal-footer="{ cancel }">
      <b-button variant="outline-primary" @click="cancel">
        {{ $t('global.action.cancel') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import LocalTable from './ModalBody/Table'
import Footer from './ModalBody/Footer'

export default {
  components: {
    LocalTable,
    Footer,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },

    attrs: {
      type: Object,
      required: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    fullObject: {},
  },
  emits: ['update:fullObject', 'addNewData'],
  data() {
    return {
      isBusy: false,
      isEditing: false,
      totalCount: null,
      selectedRowsLength: 0,
    }
  },
  computed: {
    slotFields() {
      return this.attrs?.tableFields ? this.attrs.tableFields.filter((v) => v.isSlot) : []
    },
    isEmpty() {
      return this.attrs?.isMandatory ? this.selectedRowsLength === 0 : false
    },
  },
  methods: {
    handleAdd() {
      // show the custom modal
      if (this.attrs['has:createModal']) {
        this.$bvModal.show(`${this.attrs.name}-create-data-modal`)
        return
      }

      this.isEditing = true
      this.$refs['table-modal-ref'].HandleAdd()
    },
    handleHide() {
      const table = this.$refs['table-modal-ref']
      if (table) table.handleHide()

      this.totalCount = null
      this.isEditing = false
      this.selectedRowsLength = 0

      this.context.blurHandler()
    },
    handleApply() {
      const { selectedValues, selectedObject } = this.$refs['table-modal-ref'].HandleApply()
      // Filter out the selected values that are false (unselected)
      const trueSelected = Object.keys(selectedValues).filter((value) => {
        return selectedValues[value] === true
      })

      let fullObject
      if (this.multiple) {
        fullObject = trueSelected.map((selected) => {
          return selectedObject[selected]
        })
      } else {
        fullObject = selectedObject[trueSelected[0]] || {}
      }

      this.$emit('update:fullObject', fullObject)
      this.context.model = this.multiple ? trueSelected : trueSelected[0]

      this.context.blurHandler()
    },
    handleRowSelected(selectedValuesLength) {
      this.selectedRowsLength = selectedValuesLength
    },
  },
}
</script>
